import { categories } from "@/mocks/comics";

const quickLinks = [
  { href: "#category", label: "分类目录" },
  { href: "#hot", label: "热门漫画" },
  { href: "#collection", label: "精选合集" },
  { href: "#update", label: "最新更新" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <>
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="flex flex-col items-center gap-6 rounded-xl border border-background-200/70 bg-background-50 px-6 py-10 text-center md:flex-row md:justify-between md:px-10 md:text-left">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                开始你的追漫之旅
              </h2>
              <p className="mt-2 max-w-lg text-sm text-foreground-600 md:text-base">
                从热门连载到冷门佳作，漫漫漫画海量全集一网打尽，今天就从你想看的那一本开始。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览热门漫画
              </a>
              <a
                href="#collection"
                className="whitespace-nowrap rounded-full bg-accent-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                查看精选合集
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-background-800 text-background-100">
        <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
            <div className="lg:col-span-1">
              <a href="#home" className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className="ri-book-2-fill text-lg"></i>
                </span>
                <span className="font-heading text-xl font-bold text-background-50">漫漫漫画</span>
              </a>
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
                漫漫漫画聚合全站漫画大全与全集目录，分类清晰、合集丰富，海量作品一网打尽，找漫不迷路。
              </p>
              <div className="mt-5 flex gap-2">
                <a
                  href="#home"
                  aria-label="微博"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-weibo-line"></i>
                </a>
                <a
                  href="#home"
                  aria-label="微信"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-wechat-line"></i>
                </a>
                <a
                  href="#home"
                  aria-label="哔哩哔哩"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-play-circle-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50">快速导航</h3>
              <ul className="mt-4 space-y-2.5">
                {quickLinks.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      className="text-sm text-background-200 transition-colors hover:text-accent-500"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50">漫画分类</h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5">
                {categories.slice(0, 8).map((c) => (
                  <li key={c.id}>
                    <a
                      href="#category"
                      className="inline-flex items-center gap-1 text-sm text-background-200 transition-colors hover:text-accent-500"
                    >
                      <i className={`${c.icon} text-xs`}></i>
                      {c.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50">联系我们</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-background-200">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-accent-500"></i>
                  contact@manmancomic.com
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-customer-service-2-line text-accent-500"></i>
                  在线客服：每日 9:00 - 22:00
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-message-3-line text-accent-500"></i>
                  反馈问题或版权合作，欢迎随时来信
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-700/60 pt-6 sm:flex-row">
            <p className="text-xs text-background-300">
              © {new Date().getFullYear()} 漫漫漫画. 尊重原创，支持正版漫画。
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a href="#faq" className="text-xs text-background-300 transition-colors hover:text-accent-500">
                使用帮助
              </a>
              <a href="#about" className="text-xs text-background-300 transition-colors hover:text-accent-500">
                版权声明
              </a>
              <a href="#faq" className="text-xs text-background-300 transition-colors hover:text-accent-500">
                隐私政策
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}